import { DeliveryOrderBatchScanPage } from "@/features/delivery-order-batch/pages/DeliveryOrderBatchScanPage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute(
	"/admin/delivery-order-batch/$deliveryOrderBatchID/",
)({
	beforeLoad({ context }) {
		if (
			!context.authAdapter.can({ permissions: ["delivery_order.batch_generate"] })
		) {
			throw redirect({ to: "/403" });
		}
	},
	component: DeliveryOrderBatchScanPage,
});
